export default {
  validate: function (value) {
    // eslint-disable-next-line
    var regex = /^(?=.*[a-z])[a-z0-9]{4,20}$/

    return regex.test(value)
  }
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/idcheck.js